import API from 'services/API';

export default function getCountriesList() {
  return API.request({
    method: 'GET',
    url: `/dicts/countries`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
